import { Component } from '@angular/core';
import { LIFERAY_WEB_CONSTANT } from '../../../utils/liferay.constant';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrl: './terms-of-use.component.scss'
})
export class TermsOfUseComponent {
  contentId = LIFERAY_WEB_CONSTANT.termsOfUSe.id;
}
